var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3_857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.214 30.598C104.167 28.6454 104.167 25.4796 102.214 23.527L100.473 21.7855C98.5204 19.8329 95.3546 19.8329 93.402 21.7855L65.5355 49.652C63.5829 51.6046 60.4171 51.6046 58.4645 49.652L30.598 21.7855C28.6454 19.8329 25.4796 19.8329 23.527 21.7855L21.7855 23.527C19.8329 25.4796 19.8329 28.6454 21.7855 30.598L49.652 58.4645C51.6046 60.4171 51.6046 63.5829 49.652 65.5355L21.7855 93.402C19.8329 95.3546 19.8329 98.5204 21.7855 100.473L23.527 102.214C25.4796 104.167 28.6454 104.167 30.598 102.214L58.4645 74.348C60.4171 72.3954 63.5829 72.3954 65.5355 74.348L93.402 102.214C95.3546 104.167 98.5204 104.167 100.473 102.214L102.214 100.473C104.167 98.5204 104.167 95.3546 102.214 93.402L74.348 65.5355C72.3954 63.5829 72.3954 60.4171 74.348 58.4645L102.214 30.598Z",
    fill: "#FF5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.507 24.2341C103.069 25.7962 103.069 28.3288 101.507 29.8909L73.6409 57.7574C71.2978 60.1005 71.2978 63.8995 73.6409 66.2426L101.507 94.1091C103.069 95.6712 103.069 98.2038 101.507 99.7659L99.7659 101.507C98.2038 103.069 95.6712 103.069 94.1091 101.507L66.2426 73.6409C63.8995 71.2978 60.1005 71.2978 57.7574 73.6409L29.8909 101.507C28.3288 103.069 25.7962 103.069 24.2341 101.507L22.4926 99.7659C20.9305 98.2038 20.9305 95.6712 22.4926 94.1091L50.3591 66.2426C52.7022 63.8995 52.7022 60.1005 50.3591 57.7574L22.4926 29.8909C20.9305 28.3288 20.9305 25.7962 22.4926 24.2341L24.2341 22.4926C25.7962 20.9305 28.3288 20.9305 29.8909 22.4926L57.7574 50.3591C60.1005 52.7022 63.8995 52.7022 66.2426 50.3591L94.1091 22.4926C95.6712 20.9305 98.2038 20.9305 99.7659 22.4926L101.507 24.2341Z",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3_857",
    x: 0.321045,
    y: 0.321045,
    width: 123.358,
    height: 123.358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.366667 0 0 0 0 0.366667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_857"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.148056 0 0 0 0 0.148056 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3_857",
    result: "effect2_dropShadow_3_857"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3_857",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNew);
export default __webpack_public_path__ + "static/media/close_new.6f8c0eb7.svg";
export { ForwardRef as ReactComponent };